import React, { useState } from 'react';
import { FiChevronDown, FiPhone, FiMail, FiMapPin, FiClock } from 'react-icons/fi';
import { FiFacebook, FiTwitter, FiInstagram, FiYoutube } from 'react-icons/fi';
import './BiographyPage.css';
import './ContactUs.css';

const ContactUsPage = ({ onBack, onNavigate }) => {
  const navigate = (target) => {
    if (onNavigate) onNavigate(target);
    else if (onBack) onBack();
  };

  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
  };

  return (
    <div style={{ background: '#FFFFFF', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>

      {/* Navbar */}
      <nav className="bio-navbar">
        <div className="bio-navbar-logo">
          <img src="/Sndp/logo.png" alt="Pravasi SNDP Yogam Logo" />
        </div>
        <div className="bio-navbar-links">
          <div className="bio-nav-menu">
            <a href="#home" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('home'); }}>Home</a>
            <div className="bio-nav-about-wrapper">
              <span className="bio-nav-link bio-nav-dropdown">
                About <FiChevronDown size={14} />
              </span>
              <div className="bio-nav-about-dropdown">
                <button onClick={() => navigate('ourhistory')}>Our History</button>
                <button onClick={() => navigate('leadership')}>Leadership</button>
              </div>
            </div>
            <a href="#gallery" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('gallery'); }}>Gallery</a>
            <a href="#news" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('news'); }}>News &amp; Articles</a>
            <a href="#eventcalendar" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('eventcalendar'); }}>Event Calendar</a>
            <a href="#constitution" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('constitution'); }}>Constitution</a>
            <a href="#membership" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('membership'); }}>Membership</a>
            <a href="#contact" className="bio-nav-link" style={{ fontWeight: 700, color: '#000000' }}>Contact Us</a>
          </div>
          <a href="#donate" className="bio-donate-btn">Donation</a>
        </div>
      </nav>

      {/* Contact Section */}
      <section
        className="contact-us"
        id="contact"
        style={{
          backgroundImage: "url('/Sndp/567575675756-scaled.jpg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          padding: '60px 83px',
          minHeight: '1024px',
          marginTop: 0,
          position: 'relative',
        }}
      >
        <div style={{ position: 'absolute', inset: 0, background: 'rgba(255,255,255,0.65)', zIndex: 0 }} />
        <div style={{ position: 'relative', zIndex: 1 }}>
        <h2 className="contact-heading">Contact Us</h2>

        <div className="contact-content">
          {/* Contact Info */}
          <div className="contact-info">
            <div className="contact-item">
              <div className="contact-icon"><FiPhone size={42} color="#FFC501" /></div>
              <div className="contact-details">
                <h3>Call</h3>
                <p>084524145547</p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon"><FiMail size={42} color="#FFC501" /></div>
              <div className="contact-details">
                <h3>Email</h3>
                <p className="email-link">sndpyogamuk@gmail.com</p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon"><FiMapPin size={42} color="#FFC501" /></div>
              <div className="contact-details">
                <h3>Location</h3>
                <p>ALMONDSBURY CREATIVE<br />10 GLOUCESTER ROAD<br />BRISTOL.BS32 4AA</p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon"><FiClock size={42} color="#FFC501" /></div>
              <div className="contact-details">
                <h3>Hours</h3>
                <p>Monday - Saturday<br />9:30 - 11:30am</p>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-field">
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-field">
              <input
                type="email"
                name="email"
                placeholder="Email address"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-field">
              <textarea
                name="message"
                placeholder="Message"
                value={formData.message}
                onChange={handleChange}
                rows="5"
                required
              />
            </div>
            <button type="submit" className="submit-btn">Send now</button>
          </form>
        </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bio-footer">
        <div className="bio-footer-main">
          <div className="bio-footer-brand">
            <div className="bio-footer-logo-row">
              <img src="/Sndp/logo.png" alt="Logo" className="bio-footer-logo-img" />
              <div className="bio-footer-brand-info">
                <h3 className="bio-footer-brand-name">Pravasi SNDP Yogam, UK Bristol</h3>
                <p className="bio-footer-brand-desc">
                  We, Pravasi SNDP Yogam members, are the devotees of Sree Narayana Guru,
                  a revered saint and social reformer from Kerala, India (1854-1928).
                </p>
                <div className="bio-footer-socials">
                  <a href="#facebook" aria-label="Facebook"><FiFacebook size={20} color="#FFC501" /></a>
                  <a href="#twitter" aria-label="Twitter"><FiTwitter size={20} color="#FFC501" /></a>
                  <a href="#instagram" aria-label="Instagram"><FiInstagram size={20} color="#FFC501" /></a>
                  <a href="#youtube" aria-label="YouTube"><FiYoutube size={28} color="#FFC501" /></a>
                </div>
              </div>
            </div>
          </div>

          <div className="bio-footer-contact">
            <h4 className="bio-footer-column-title">Contact Us</h4>
            <div className="bio-footer-contact-list">
              <div className="bio-footer-contact-item">
                <FiMapPin size={20} color="#FFC501" />
                <span>Almondsbury Creative 10 Gloucester Road, Bristol</span>
              </div>
              <div className="bio-footer-contact-item">
                <FiPhone size={20} color="#FFC501" />
                <span>+91 84524145547</span>
              </div>
              <div className="bio-footer-contact-item">
                <FiMail size={20} color="#FFC501" />
                <span>sndpyogamuk@gmail.com</span>
              </div>
            </div>
          </div>

          <div className="bio-footer-links">
            <h4 className="bio-footer-column-title">Quick Links</h4>
            <ul className="bio-footer-nav">
              <li><a href="#home" onClick={onBack}>Home</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#history">History</a></li>
              <li><a href="#organization">Organization</a></li>
              <li><a href="#sree-narayana-guru">Sree Narayana Guru</a></li>
              <li><a href="#articles">Articles</a></li>
              <li><a href="#gallery" onClick={(e) => { e.preventDefault(); navigate('gallery'); }}>Gallery</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          <div className="bio-footer-newsletter">
            <h4 className="bio-footer-column-title">Newsletter</h4>
            <p className="bio-newsletter-desc">Subscribe to our Newsletter</p>
            <div className="bio-newsletter-form">
              <input type="email" placeholder="Enter your email" />
              <button type="button">Subscribe</button>
            </div>
          </div>
        </div>

        <div className="bio-footer-bottom">
          <span>© 2025 Pravasi SNDP Yogam. All rights reserved.</span>
          <div className="bio-footer-bottom-links">
            <a href="#terms">Terms of Use</a>
            <a href="#privacy">Privacy Policy</a>
          </div>
        </div>
      </footer>

    </div>
  );
};

export default ContactUsPage;
